module.exports = __webpack_public_path__ + "static/media/HandIconGreen.1ed123b3.svg";